export default "__VITE_ASSET__B0WPEhc3__"